// ============================================================================
// @gs/i18n/localeContext — contexte locale LEGER (zero dependance i18next)
// ============================================================================
// Consomme par @gs/ui (GsUserMenu, selecteur Langue) sans tirer i18next dans
// le bundle des apps NON migrees : ce module n'importe que React. Le provider
// reel (GsLocaleProvider, exporte par @gs/i18n racine) branche ce contexte sur
// i18next ; sans provider, useLocale() retourne null et les consommateurs
// masquent leur controle (apps non migrees = aucun controle mort affiche).

import { createContext, useContext } from 'react';

export type SupportedLocale = 'fr' | 'en';

export const DEFAULT_LOCALE: SupportedLocale = 'fr';
export const SUPPORTED_LOCALES: SupportedLocale[] = ['fr', 'en'];

export interface LocaleContextValue {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

/**
 * Locale courante + setter, ou `null` si aucun GsLocaleProvider n'est monte
 * (app non migree i18n) — les consommateurs (GsUserMenu) masquent alors le
 * controle de langue au lieu d'afficher un placeholder mort.
 */
export function useLocale(): LocaleContextValue | null {
  return useContext(LocaleContext);
}
